/**
 * @module helper.image
 */

/**
 * return a Promise that will resolve a new dataURL or reject an empty string.
 * @async
 */
export function resizeImageDataUrl(dataURL: string, { width, height }: { width: number, height: number }) {
	return new Promise<string>((resolve, reject) => {
		const img = document.createElement('img');
		const [, type = ''] = /data:image\/([a-z]*);.*/.exec(dataURL) || [];

		if (!type) {
			reject('');
		}

		img.onload = () => {
			const canvas = document.createElement('canvas');
			const ctx = canvas.getContext('2d');
			canvas.width = width;
			canvas.height = height;
			if (ctx) {
				ctx.drawImage(img, 0, 0, img.width, img.height, 0, 0, width, height);
				resolve(canvas.toDataURL(`image/${type}`, 1));
			} else {
				reject('');
			}
		};
		img.src = dataURL;
	});
}
